/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import {getTestProps} from '@benchling/js-test-utils';
import classNames from 'classnames';
import React from 'react';

import * as OrgActions from 'actions/OrganizationActions';
// @ts-expect-error
import * as UserActions from 'actions/UserActions';
import * as analytics from 'analytics/Analytics';
import DataConnector from 'connect/DataConnector';
import EntityName from 'orgs/EntityName';
import {OrganizationRequest as OrganizationRequestType} from 'orgs/OrganizationConstants';
import OrganizationRequest from 'orgs/OrganizationRequest';
import EntityStore from 'stores/EntityStore';

interface InboundRequestCardProps {
  organization: any;
  user: any;
}

const InboundRequestCard = ({organization, user}: InboundRequestCardProps): JSX.Element => {
  const accept = (): void => {
    OrgActions.acceptInboundRequest(organization.id, user.id);
  };

  const reject = (): void => {
    OrgActions.rejectInboundRequest(organization.id, user.id);
  };

  analytics.track('organizations', 'viewed_join_organization_request', {
    user_id: EntityStore.currentUser()?.id,
    organization_id: organization.id,
    requestor_id: user.id,
  });

  return (
    <OrganizationRequest accept={accept} reject={reject} collapsed={false}>
      <div>
        <EntityName entity={user} /> has requested to join <EntityName entity={organization} />.
      </div>
    </OrganizationRequest>
  );
};

interface OutboundRequestCardProps {
  inviter: any;
  organization: any;
}

const OutboundRequestCard = ({organization, inviter}: OutboundRequestCardProps): JSX.Element => {
  const accept = (): void => {
    UserActions.acceptOutboundRequest(organization.id);
  };

  const reject = (): void => {
    UserActions.rejectOutboundRequest(organization.id);
  };

  analytics.track('organizations', 'viewed_organization_invite', {
    user_id: EntityStore.currentUser()?.id,
    organization_id: organization.id,
  });

  return (
    <OrganizationRequest accept={accept} reject={reject} collapsed={false}>
      <div>
        <EntityName entity={inviter} /> invited you to join <EntityName entity={organization} />.
      </div>
    </OrganizationRequest>
  );
};

const PendingInvitesCard = (): JSX.Element => (
  <div className="organizationInvitesSection-inviteCard u-overflow-hidden">
    <div className="legacy-font-proxima-17 u-small-spacing-bottom u-bold-font-weight">
      You have an organization invite
    </div>
    <div>Accept the invite in your email inbox or verify your email address to see the invite here.</div>
  </div>
);

class OrganizationInvitesSectionConnector extends DataConnector<
  OrganizationInvitesSectionProps,
  EnhancedOrganizationInvitesSectionProps
> {
  override entityStore: any;
  override shouldSubscribeToRedux = false;
  override stores = [EntityStore];

  enhanceProps(): EnhancedOrganizationInvitesSectionProps {
    const currentUser = this.entityStore().currentUser();
    if (!currentUser) {
      return {currentUserInboundRequests: null, userOrgsInboundRequests: null, pendingOrgInvites: 0};
    }
    const {userOrgsInboundRequests, currentUserInboundRequests, pendingOrgInvites} = currentUser;
    return {userOrgsInboundRequests, currentUserInboundRequests, pendingOrgInvites};
  }
}

interface OrganizationInvitesSectionProps {
  className?: string;
}
interface EnhancedOrganizationInvitesSectionProps {
  currentUserInboundRequests?: Array<OrganizationRequestType> | null;
  userOrgsInboundRequests?: Array<OrganizationRequestType> | null;
  pendingOrgInvites: number;
}

class OrganizationInvitesSection extends React.Component<
  OrganizationInvitesSectionProps & EnhancedOrganizationInvitesSectionProps
> {
  override componentDidMount(): void {
    UserActions.loadOrgRequests();
  }

  override render(): JSX.Element | null {
    const {currentUserInboundRequests, userOrgsInboundRequests, pendingOrgInvites} = this.props;
    if (!EntityStore.currentUserHasPendingInvites()) {
      return null;
    }

    return (
      <div
        className={classNames(this.props.className, 'organizationInvitesSection')}
        {...getTestProps({component: 'OrganizationInvitesSection', element: 'root'})}
      >
        {currentUserInboundRequests &&
          currentUserInboundRequests.map(({organization, inviter}) => (
            <OutboundRequestCard
              key={`${organization.handle}-${inviter.handle}`}
              organization={organization}
              inviter={inviter}
            />
          ))}
        {userOrgsInboundRequests &&
          userOrgsInboundRequests.map(({organization, user}) => (
            <InboundRequestCard
              key={`${organization.handle}-${user.handle}`}
              organization={organization}
              user={user}
            />
          ))}
        {pendingOrgInvites > 0 && <PendingInvitesCard />}
      </div>
    );
  }
}

export default OrganizationInvitesSectionConnector.connect(OrganizationInvitesSection);
